import { TemplatePage } from './types';

const introOutroPage: TemplatePage = {
  header: {
    color: '#97DEF0',
    icon: 'images/video-templates/intro_outro.jpg',
    title: 'Free Video Intro & Outro Templates',
    title_meta: '100+ Free Customizable Video Intro & Outro Templates',
    description_meta:
      'Choose from 100+ customizable video intro & outro templates to create a beginning and ' +
      'ending scene for your video that will hook the audience right away.',
    description:
      'Create a beginning and ending scene for your video that hooks the audience right away with these 100+ ' +
      'customizable video intro & outro templates. Pick a template of your choice and make a great impression with ' +
      'eye-catching intro & outro videos. '
  },
  footer: {
    category: 'Intro & Outro',
    description:
      'With Wave.video’s broad range of professionally made video intro & outro templates, you can create ' +
      'eye-catching videos for your social media, blog, website, or email newsletter in a matter of minutes. ' +
      'All the templates are free and easy to personalize to suit your messaging.'
  },
  content: [
    {
      type: 'templates',
      title: 'Video Intro & Outro  Video Templates',
      search: { category: '/Use Cases/Intro & Outro' }
    },
    {
      type: 'stocks',
      title: 'intro & outro',
      search: { name: 'intro outro' }
    },
    { type: 'calendar' }
  ]
};

export default introOutroPage;
